<div id="activate-account" class="flex flex-col" fusePerfectScrollbar>
  <div id="activate-account-form-wrapper" class="flex flex-col items-center justify-center">
    <div id="activate-account-form" *fuseIfOnDom [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
      <div class="logo">
        <mat-icon class="s-96">check_circle</mat-icon>
      </div>

      <div i18n class="title">Учетная запись активирована!</div>

      <div class="subtitle">
        <p i18n>Вы успешно зарегистрировались в сервисе.</p>
        <p i18n
          >Перейдите по ссылке "Перейти на страницу авторизации" и введите данные, которые Вы указали при
          регистрации.</p
        >
      </div>

      <div class="message" *ngIf="userOrign">
        <a i18n class="link" href="{{ userOrign }}" target="_self">Перейти на страницу авторизации</a>
      </div>
    </div>
  </div>
</div>
